import React, { useState } from 'react';
import { GoogleLogin, type CredentialResponse } from '@react-oauth/google';
import { Box, Typography, Alert } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../state/AuthContext';
import { FlameMark } from '../../assets/FlameMark';
import { Wordmark } from '../../assets/Wordmark';

const LoginScreen: React.FC = () => {
  const { t } = useTranslation();
  const { loginWithGoogle } = useAuth();
  const [error, setError] = useState<string | null>(null);

  const handleSuccess = async (response: CredentialResponse): Promise<void> => {
    if (!response.credential) return;
    setError(null);
    try {
      await loginWithGoogle(response.credential);
    } catch (err) {
      setError(err instanceof Error ? err.message : t('login.failed'));
    }
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 3,
        p: 3,
        backgroundColor: '#F5F5F5',
      }}
    >
      <FlameMark sx={{ fontSize: 56, color: 'primary.main' }} />
      <Wordmark />
      <Typography variant="h5" fontWeight={700} textAlign="center">
        {t('login.title')}
      </Typography>
      {error && <Alert severity="error">{error}</Alert>}
      <GoogleLogin onSuccess={handleSuccess} onError={() => setError(t('login.googleError'))} />
    </Box>
  );
};

export default LoginScreen;
